module.exports = __webpack_public_path__ + "static/media/rentman.cacd6214.svg";